import { createContext } from 'react';

/**
 * - `light` / `dark` — pinned.
 * - `system` — follow the OS `prefers-color-scheme`.
 */
export type ThemeMode = 'light' | 'dark' | 'system';

export interface ThemeContextType {
  /** The resolved appearance currently applied. */
  isDarkMode: boolean;
  /** The user's chosen mode (how `isDarkMode` is derived). */
  mode: ThemeMode;
  setMode: (mode: ThemeMode) => void;
  /** Binary flip to an explicit light/dark — kept for the simple toggle. */
  toggleTheme: () => void;
}

const defaultContextValue: ThemeContextType = {
  isDarkMode: false,
  mode: 'system',
  setMode: () => {},
  toggleTheme: () => {},
};

export const ThemeContext = createContext<ThemeContextType>(defaultContextValue);



